import { getProxyRaw } from '@rehaje/shared'

export function is(target?: any, source?: any): boolean {
  if (target === source) return true
  if (typeof target !== typeof source) return false
  if (typeof target !== 'object' || target === null) return false
  return getProxyRaw(target) === getProxyRaw(source)
}
